<nz-form-item class="ui-form-select" [ngStyle]="{ margin: hideMargin ? '0' : '0 0 24px' }">
  <nz-form-label *ngIf="!hideLabel" [nzRequired]="isRequired">{{
    label | localization
  }}</nz-form-label>
  <nz-form-control [nzValidateStatus]="control ?? 'success'" [nzErrorTip]="errorTip | localization">
    <nz-select
      [ngModel]="value"
      (ngModelChange)="onValueChange($event)"
      (nzOpenChange)="onSelectOpened($event)"
      (nzBlur)="onTouched()"
      (nzFocus)="onTouched()"
      [nzDisabled]="disabled"
      [nzPlaceHolder]="placeholder | localization"
      [nzAllowClear]="!required"
      [nzMode]="selectMode"
      [nzShowSearch]="showSearch"
      [nzServerSearch]="serverSearch"
      (nzOnSearch)="onSearch($event)"
      (nzScrollToBottom)="loadMore()"
      nzDropdownClassName="ui-form-select-dropdown"
      [compareWith]="compareFn"
      [nzOptionHeightPx]="48"
      [nzMaxTagCount]="5"
      [nzCustomTemplate]="optionIconField ? customTemplate : null"
    >
      @if (!isLoadingData) { @for (option of options; track getUniqueKey(option, $index)) {
      <nz-option
        [nzLabel]="option | getFieldValue : optionLabelField | localization"
        [nzValue]="option | getFieldValue : optionValueField"
        [nzCustomContent]="isCustomContent || optionIconField"
        [style.height.px]="48"
        [style.min-height.px]="48"
      >
        <div class="flex items-center gap-1">
          @if (optionIconField) {
            <ui-icon [name]="option | getFieldValue : optionIconField" size="20px" class="inline"  color="black"></ui-icon>
          }
          @if (isCustomContent) {
            @for (field of customOptionFields; track field) {
              @if ((option | getFieldValue : field)?.toString().trim() !== '') {
                <span class="text-base block">{{ option | getFieldValue : field | localization }}</span>
              }
            }
          } @else {
            <span>{{ option | getFieldValue : optionLabelField | localization }}</span>
          }
        </div>
      </nz-option>
      } @if (isLoadingMore) {
      <nz-option nzDisabled nzCustomContent>
        <ui-loading size="16px" text="Загрузка данных..."></ui-loading>
      </nz-option>
      } } @else {
      <nz-option nzDisabled nzCustomContent>
        <ui-loading size="16px" text="Загрузка данных..."></ui-loading>
      </nz-option>
      }
    </nz-select>
  </nz-form-control>
</nz-form-item>

<ng-template #customTemplate let-selected>
  <div class="flex items-center gap-2">
    <ui-icon [name]="selected.nzValue" size="16px"></ui-icon>
    <span>{{ selected.nzLabel }}</span>
  </div>
</ng-template>
